import React from 'react';
import { Paper, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

function Privacy() {
  const { translate } = useLanguage();
  const navigate = useNavigate();

  return (
    <Paper sx={{ p: { xs: 3, sm: 4 }, maxWidth: 800, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom sx={{ color: 'primary.main', mb: 3 }}>
        {translate('privacy.title')}
      </Typography>
      
      <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
        {translate('privacy.lastUpdated')}: December 23, 2025
      </Typography>

      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          {translate('privacy.dataCollection')}
        </Typography>
        <Typography variant="body1" paragraph>
          {translate('privacy.dataCollectionText')}
        </Typography>
      </Box>

      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          {translate('privacy.localStorage')}
        </Typography>
        <Typography variant="body1" paragraph>
          {translate('privacy.localStorageText')}
        </Typography>
      </Box>

      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          {translate('privacy.cookies')}
        </Typography>
        <Typography variant="body1" paragraph>
          {translate('privacy.cookiesText')}
        </Typography>
      </Box>

      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          {translate('privacy.thirdParty')}
        </Typography>
        <Typography variant="body1" paragraph>
          {translate('privacy.thirdPartyText')}
        </Typography>
      </Box>

      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          {translate('privacy.rights')}
        </Typography>
        <Typography variant="body1" paragraph>
          {translate('privacy.rightsText')}
        </Typography>
      </Box>

      <Button 
        variant="contained" 
        onClick={() => navigate('/')}
        sx={{ mt: 2 }}
      >
        {translate('privacy.backHome')}
      </Button>
    </Paper>
  );
}

export default Privacy;
